import { withUnmountTransition } from '../../../../../misc/withUnmountTransition.hoc'
import { InsiReviewAndValidateModal } from './InsiReviewAndValidateModal.component'

const withUnmountHoc = withUnmountTransition(InsiReviewAndValidateModal)
export { withUnmountHoc as InsiReviewAndValidateModal }
